var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionUserShare16({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9c2 0 4 1 4 2.5V13H1v-1.5C1 10 3 9 5 9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.5V13h-4v-1.5c0-.996-.381-1.805-.908-2.432C10.39 9.023 10.695 9 11 9c2 0 4 1 4 2.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionUserShare16);
export default __webpack_public_path__ + "static/media/ic_action_user_share_16.f15f728f6bab3ef656d94a0639937424.svg";
export { ForwardRef as ReactComponent };